import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  class: "footer-app-ctn"
}
const _hoisted_3 = { class: "cta-list" }
const _hoisted_4 = { onclick: "Optanon.ToggleInfoDisplay()" }

import { Capacitor } from '@capacitor/core';

import { defineComponent, onUnmounted, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterView, useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const __default__ = defineComponent({
  name: 'HomeView',
});


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()
const link = window.location.href
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const app = ref()

let winHeight = ref(window.innerHeight)
let type = ref('desktop')

const resize = () => { winHeight.value = window.innerHeight } 

if (Capacitor.getPlatform() === 'web' && !Capacitor.isNativePlatform()) type.value = 'desktop';
else type.value = "mobile";
if (window.matchMedia('(display-mode: standalone)').matches) type.value = "mobile"

window.addEventListener('contextmenu', function (e: MouseEvent) { e.preventDefault(); return false; }, false);

if (!window.matchMedia('(display-mode: standalone)').matches)
  window.addEventListener("beforeunload", () => {
    store.dispatch('setAgeValid', false) 
  })

onMounted(() => {
  console.log('commit:', process.env.VUE_APP_COMMIT)
  app.value.onresize = resize
})

onUnmounted(() => { 
  store.dispatch('setAgeValid', false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("head", null, [
      _createElementVNode("link", {
        rel: "canonical",
        href: `${_unref(link)}`
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", {
      class: "app-ctn",
      ref_key: "app",
      ref: app,
      style: _normalizeStyle(`overflow-y: ${_unref(type) === 'desktop'? 'scroll': 'hidden'};`)
    }, [
      _createVNode(_unref(RouterView)),
      (_unref(type) === 'desktop' && _unref(route).name !== 'ageguard')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("hr", {
              size: "2",
              width: "90%",
              color: "grey"
            }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({path: '/en/legal/TermsAndCondition'})))
              }, _toDisplayString(_unref(t)("Legal-Terms")), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("Cookie-Policies")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 64))
}
}

})